import type { v4 } from '@sap/ux-specification-types';
import { syncRule, validity } from '../../../common/decoration/decorators';
import { getActionsPathForOP } from '../../application';
import { CustomActionOPBase } from './ObjectPageToolBarAction';

export class CustomFormActionOP extends CustomActionOPBase implements v4.CustomFormActionOP {
    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.84.0'
    })
    press: string;

    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.142.0'
    })
    overflowGroup?: number;

    @syncRule({
        manifest: {
            path: getActionsPathForOP
        }
    })
    @validity({
        since: '1.139.0'
    })
    priority?: v4.ActionPriority;
}
